import uiI18n from "../i18n";
import { apiRequest, ApiError, getCurrentUser, jsonOptions } from './apiClient';
const encode = encodeURIComponent;
// Messaging limits of the API (HTTP 429, distinct codes): translated, the code stays on the error.
const LIMIT_MESSAGES = { too_many_consecutive_messages: "messages.limit_consecutive", too_many_new_conversations: "messages.limit_new_conversations" };
export async function getAllConversation() {
  const user = await getCurrentUser();
  const data = await apiRequest('Message/getAllConversation/' + encode(user.uid));
  return (Array.isArray(data) ? data : []).filter(c => c.senderId === user.uid || c.receiverId === user.uid).map(c => ({
    ...c, propertyId: c.isVacation ? (c.propertyId || c.adsID) : (c.bienId || c.adsID || c.propertyId),
  }));
}
async function participant(conversationId) {
  const conversations = await getAllConversation();
  const conversation = conversations.find(c => c.conversationId === conversationId);
  if (!conversation) throw new ApiError(403, uiI18n.t("ui.this_conversation_is_not_accessible"));
  return conversation;
}
export async function getConversation(conversationId) {
  const user = await getCurrentUser();
  await participant(conversationId);
  return apiRequest('Message/conversation?conversationId=' + encode(conversationId) + '&senderId=' + encode(user.uid));
}
export async function sendMessage(input) {
  const user = await getCurrentUser();
  const data = Object.fromEntries(Object.entries(input).map(([key,value]) => [key.toLowerCase(), value]));
  if (!data.receiverid || data.receiverid === user.uid || !data.content?.trim()) throw new ApiError(400, uiI18n.t("ui.invalid_recipient_or_message"));
  if (data.conversationid) {
    const conversation = await participant(data.conversationid);
    const receiver = conversation.senderId === user.uid ? conversation.receiverId : conversation.senderId;
    if (receiver !== data.receiverid || conversation.propertyDetails?.isDeleted || conversation.propertyIsDeleted) throw new ApiError(409, uiI18n.t("ui.this_conversation_no_longer_accepts_new_messages"));
  }
  const propertyId = data.adsid || data.propertyid;
  if (!propertyId) throw new ApiError(404, uiI18n.t("ui.this_listing_is_no_longer_available"));
  // Do not serialize the temporary optimistic UI ID: the API expects a GUID.
  try {
    return await apiRequest('Message/send', jsonOptions('POST', {
    senderId: user.uid, receiverId: data.receiverid, content: data.content.trim(),
    propertyId, adsID: propertyId, isVacation: Boolean(data.isvacation),
    ...(data.conversationid ? { conversationId: data.conversationid } : {}),
    propertyEmail: data.propertyemail || '', propertyName: user.displayName || '',
    name: data.name || '', adLabel: data.adlabel || '', adsUrl: data.adsurl || '',
    adresse: data.adresse || '', urlImages: data.urlimages || '',
    }));
  } catch (error) {
    const key = error?.status === 429 && LIMIT_MESSAGES[error.code];
    if (key) error.message = uiI18n.t(key);
    throw error;
  }
}
export async function deleteConversationForUser(conversationId) {
  const user = await getCurrentUser();
  await participant(conversationId);
  return apiRequest('Message/DeleteForUser?conversationId=' + encode(conversationId) + '&userId=' + encode(user.uid), { method: 'DELETE' });
}
export const deleteConversation = deleteConversationForUser;
export const getConversationOld = getConversation;
export async function getConversationBySender() {
  const user = await getCurrentUser();
  return apiRequest('Message/conversationBySender/' + encode(user.uid));
}
export const getMessagesByUser = getConversationBySender;
